module.exports = __webpack_public_path__ + "static/media/background5.66a911e1.png";